import {
  faClose,
  faMagnifyingGlass,
  faPencil,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@design-system/components/typography/typography';
import { IconButton } from '@design-system/components/button/iconButton';
import {
  SwapProposal,
  doseLabel,
  exerciseNameKey,
} from '../model/swaps.domain';
import { SwapThumb } from './SwapThumb';
import * as styles from './CreatorApprovedSwaps.css';

type ModificationsListProps = {
  proposals: SwapProposal[];
  disabled?: boolean;
  onEdit: (proposal: SwapProposal) => void;
  onRemove: (proposal: SwapProposal) => void;
};

export const ModificationsList = (p: ModificationsListProps) => {
  return (
    <div className={styles.resultsList}>
      <Typography>Selected modifications ({p.proposals.length})</Typography>
      {p.proposals.map((proposal) => {
        const nameKey = exerciseNameKey(proposal.name);
        return (
          <div key={nameKey} className={styles.listRow}>
            <SwapThumb media={proposal.media} />
            <div className={styles.rowText}>
              <Typography>{proposal.name}</Typography>
              <span className={styles.dose}>{doseLabel(proposal.sets)}</span>
            </div>
            <div className={styles.rowActions}>
              <IconButton
                variant="text"
                color="neutral"
                icon={faPencil}
                disabled={p.disabled}
                testId={`swap-edit-${nameKey}`}
                onClick={() => p.onEdit(proposal)}
              />
              <IconButton
                variant="text"
                color="neutral"
                icon={faClose}
                disabled={p.disabled}
                testId={`swap-remove-${nameKey}`}
                onClick={() => p.onRemove(proposal)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
